export const APP_REDIRECTS = {
    '/profile/lock': '/'
}